import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';
import './Home.content.style.scss';
import PerfectScrollbar from 'react-perfect-scrollbar';
import LineChart from '@/components/LineChart/LineChart';
import Bigger from '@/components/Bigger/Bigger';
import KpiCard from '@/components/Kpi-card/KpiCard';
import CustomTable from '@/components/CustomTable/CustomTable';
import DashboardFilter from '@/components/DashboardFilter/dashboard-filter';
import {
	selectDashboardKPI,
	selectIsLoadingLineChartAbonnement,
	selectIsLoadingLineChartResiliation,
	selectLineGraphAbonnement,
	selectLineGraphResiliation,
	selectTableauGlobal,
	selectTableauGlobalResilie,
	selectTableauSecteur,
} from '@/store/reducers/dashboard/dashboard.selector';
import { ConnectedProps, connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
	selectToggleBigger1,
	selectToggleBigger2,
} from '@/store/reducers/general_param/general_param.selector';
import * as moment from 'moment';
import 'moment/locale/fr';
import {
	tableau_1,
	tableau_abonnement,
	tableau_resiliation,
} from '@/config/initData';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

type PropsFromRedux = ConnectedProps<typeof connector>;

const CtHomeFct: React.FC<PropsFromRedux> = ({
	kpi_amount,
	isBigger1,
	isBigger2,
	lineGraphResiliation,
	lineGraphAbonnement,
	tableauSecteur,
	tableauGlobal,
	tableauGlobalResilie,
	isLineChartResiliationLoading,
	isLineChartAbonnementLoading,
}) => {
	const theme = useTheme();
	const matches_down_xl = useMediaQuery(theme.breakpoints.down('xl'));
	const matches_down_lg = useMediaQuery(theme.breakpoints.down('lg'));
	const matches_down_sm = useMediaQuery(theme.breakpoints.down('sm'));
	const [perimetreSelected, setPerimetreSelected] = useState('');
	const [positionAbonnementSelected, setPositionAbonnementSelected] =
		useState('');

	const options = {
		chart: {
			type: 'spline',
			zoomType: 'xy',
			height: matches_down_lg
				? matches_down_sm
					? '100%'
					: '45%'
				: '55%',
		},
		resetZoomTitle: 'Test',
		title: {
			text: '',
		},
		legend: {
			layout: 'horizontal',
		},
		xAxis: [
			{
				categories: lineGraphResiliation?.absisse,
			},
		],

		yAxis: [
			{
				title: {
					text: 'Nombre',
				},
				gridLineWidth: 0.3,
			},
			{
				title: {
					text: 'Taux',
				},
				labels: {
					format: '{value} %',
				},
				gridLineWidth: 1,
				opposite: true,
			},
		],
		plotOptions: {
			spline: {
				dataLabels: {
					enabled: false,
				},
				states: {
					hover: {
						lineWidth: 2,
					},
				},
				marker: {
					enabled: false,
				},
				// enableMouseTracking: true
			},
		},
		series: [
			{
				name: 'Dépôt de garantie décaissés ',
				color: '#94e1b1',
				yAxis: 0,
				lineWidth: 3,
				data: lineGraphResiliation?.encaisse,
			},
			{
				name: 'Abonnés resiliés',
				yAxis: 0,
				color: '#ee7e05',
				lineWidth: 3,
				data: lineGraphResiliation?.abonnes,
			},
			{
				name: 'Taux',
				yAxis: 1,
				color: '#6f99e8',
				lineWidth: 3,
				data: lineGraphResiliation?.taux,
			},
		],
		exporting: {
			enabled: true,
			scale: 2,
		},
		credits: {
			enabled: false,
		},
	};

	return (
		<>
			<PerfectScrollbar className="ct-home">
				<Box>
					<Grid container rowSpacing={2} columnSpacing={2}>
						{/* ====== ROW ====== */}
						<>
							<Grid item xs={12} sm={12} md={12} lg={4} xl={6}>
								<DisplayContentAlt height={'80px'}>
									<h2 className='uppercase'> Tableau de bord</h2>
									{matches_down_lg && (
										<>
											<div className="updated-time">
												<span className="updated-time__title">
													{' '}
													Date de mise à jour{' '}
												</span>
												<span className="updated-time__value">
													{' '}
													{kpi_amount.date_maj &&
														moment
															.default(
																kpi_amount.date_maj
															)
															.format('LL')}{' '}
												</span>
											</div>
										</>
									)}
								</DisplayContentAlt>
							</Grid>

							<Grid item xs={12} sm={12} md={12} lg={4} xl={3}>
								<DisplayContent height={'80px'}>
									<KpiCard
										icon="fa-solid:users"
										title="Nombre d'abonnés actifs"
										amount={kpi_amount.abonne}
										unit=""
										variant="1"
									/>
								</DisplayContent>
							</Grid>
							<Grid item xs={12} sm={12} md={12} lg={4} xl={3}>
								<DisplayContent height={'80px'}>
									<KpiCard
										icon="fa-solid:money-bill"
										title="Montant dépôt de garantie en caisse "
										unit="F CFA"
										amount={kpi_amount.montant}
										variant="2"
									/>
								</DisplayContent>
							</Grid>
						</>
						{/* ====== end of a ROW ====== */}

						{/* ====== ROW ====== */}
						<>
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<DisplayContent height={'fit-content'}>
									<DashboardFilter
										setPerimetreSelected={
											setPerimetreSelected
										}
										setPositionAbonnementSelected={
											setPositionAbonnementSelected
										}
									/>
								</DisplayContent>
							</Grid>
						</>
						{/* ====== end of a ROW ====== */}

						{/* ====== ROW ====== */}
						<>
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid
									container
									rowSpacing={2}
									columnSpacing={2}
								>
									<Grid
										item
										xs={12}
										sm={12}
										md={12}
										lg={6}
										xl={6}
									>
										{/* <DisplayContent height={'45vh'}> */}
										{/* <Bigger objBiggerProps={ {title:'Evolution des abonnements par trimestre',numberGraph:1 }}>
                      <LineChart
                        chartObject={lineChartDataSubscription}  isBigger={isBigger1}
                      /> */}
										<DisplayContent
											height={
												matches_down_xl
													? matches_down_sm
														? '80vh'
														: '60vh'
													: '60vh'
											}
										>
											<Bigger
												objBiggerProps={{
													title:
														'Evolution des abonnements par trimestre ' +
														(perimetreSelected ||
															'') +
														'' +
														(positionAbonnementSelected
															? ' (' +
															  positionAbonnementSelected +
															  ')'
															: ''),
													numberGraph: 1,
												}}
											>
												<LineChart
													chartObject={
														lineGraphAbonnement
													}
													numeroGraph={1}
													title="Evolution des abonnements par trimestre"
												/>
											</Bigger>
										</DisplayContent>
									</Grid>
									<Grid
										item
										xs={12}
										sm={12}
										md={12}
										lg={6}
										xl={6}
									>
										<DisplayContent
											height={
												matches_down_xl
													? matches_down_sm
														? '80vh'
														: '60vh'
													: '60vh'
											}
										>
											<Bigger
												objBiggerProps={{
													title:
														'Evolution des résilitations par trimestre ' +
														(perimetreSelected ||
															'') +
														'' +
														(positionAbonnementSelected
															? ' (' +
															  positionAbonnementSelected +
															  ')'
															: ''),
													numberGraph: 2,
												}}
											>
												{isLineChartResiliationLoading ? (
													<>
														<div className="skeleton-chart">
															<img
																src={require('@/assets/images/gif/chart-load.gif')}
																alt="load"
															/>
														</div>
													</>
												) : (
													<>
														<HighchartsReact
															highcharts={
																Highcharts
															}
															allowChartUpdate={
																true
															}
															options={options}
														/>
													</>
												)}
											</Bigger>
										</DisplayContent>
									</Grid>
								</Grid>
							</Grid>
						</>
						{/* ====== end of a ROW ====== */}

						{/* ====== ROW ====== */}
						<>
							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								xl={12}
								xxl={12}
							>
								<DisplayContent
									height={
										matches_down_xl
											? matches_down_sm
												? 'fit-content'
												: '80vh'
											: '80vh'
									}
								>
									<CustomTable
										headers={tableau_1.headers}
										rows={tableauSecteur}
										title={tableau_1.title}
										headerColor={' var(--ui-tertiary) '}
										textColor={'var(--ui-white)'}
										titleExport={tableau_1.titleExport}
										colsToExport={tableau_1.colsToExport}
										rowsPerPage={matches_down_xl ? 8 : 13}
									/>
								</DisplayContent>
							</Grid>

							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								xl={12}
								xxl={12}
							>
								<DisplayContent
									height={
										matches_down_xl
											? matches_down_sm
												? 'fit-content'
												: '80vh'
											: '80vh'
									}
								>
									<CustomTable
										headers={tableau_abonnement.headers}
										rows={tableauGlobal}
										title={tableau_abonnement.title}
										headerColor={' var(--ui-tertiary) '}
										textColor={'var(--ui-white)'}
										titleExport={
											tableau_abonnement.titleExport
										}
										colsToExport={
											tableau_abonnement.colsToExport
										}
										rowsPerPage={matches_down_xl ? 8 : 13}
									/>
								</DisplayContent>
							</Grid>

							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								xl={12}
								xxl={12}
							>
								<DisplayContent
									height={
										matches_down_xl
											? matches_down_sm
												? 'fit-content'
												: '80vh'
											: '80vh'
									}
								>
									<CustomTable
										headers={tableau_resiliation.headers}
										rows={tableauGlobalResilie}
										title={tableau_resiliation.title}
										headerColor={' var(--ui-tertiary) '}
										textColor={'var(--ui-white)'}
										titleExport={
											tableau_resiliation.titleExport
										}
										colsToExport={
											tableau_resiliation.colsToExport
										}
										rowsPerPage={matches_down_xl ? 8 : 13}
									/>
								</DisplayContent>
							</Grid>
						</>
						{/* ====== end of a ROW ====== */}
					</Grid>
				</Box>
			</PerfectScrollbar>
		</>
	);
};

const DisplayContent = styled.div<{ height: string }>`
	width: 100%;
	height: ${({ height }) => {
		return height;
	}};
	border-radius: 5px;
	background: var(--ui-white);
	box-shadow: 0px 0px 30px #ededed;
`;

const DisplayContentAlt = styled.div<{ height: string }>`
	width: 100%;
	height: ${({ height }) => {
		return height;
	}};
	border-radius: 5px;
	display: flex;
	align-items: center;

	h2 {
		color: var(--ui-dark);
	}
`;

const mapStateToProps = createStructuredSelector({
	kpi_amount: selectDashboardKPI,
	isBigger1: selectToggleBigger1,
	isBigger2: selectToggleBigger2,
	lineGraphResiliation: selectLineGraphResiliation,
	lineGraphAbonnement: selectLineGraphAbonnement,
	tableauSecteur: selectTableauSecteur,
	tableauGlobal: selectTableauGlobal,
	tableauGlobalResilie: selectTableauGlobalResilie,
	isLineChartResiliationLoading: selectIsLoadingLineChartResiliation,
	isLineChartAbonnementLoading: selectIsLoadingLineChartAbonnement,
});

const connector = connect(mapStateToProps);
const CtHome = connector(CtHomeFct);

export default CtHome;
